import { render } from "./PopupCustomer.vue?vue&type=template&id=45207194"
import script from "./PopupCustomer.vue?vue&type=script&lang=js"
export * from "./PopupCustomer.vue?vue&type=script&lang=js"

import "./PopupCustomer.vue?vue&type=style&index=0&id=45207194&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__